import { computed } from 'vue';
import { useStore } from 'vuex';

export function useThreadedComments() {
  const store = useStore();

  const createdComments = computed(() => store.state.comments.createdComments);

  const hasCreatedComments = computed(() => {
    return !!createdComments.value.length;
  });

  function sort(arr: Array<{ id: string | number }>) {
    const canBeEdited = arr.filter(({ id }) => {
      return !!createdComments.value.filter(
        (comment: { id: string | number }) => comment.id === id
      )[0];
    });

    if (!canBeEdited) {
      return arr;
    }

    const sorted = arr.slice().sort((a, b) => {
      return canBeEdited.indexOf(b) - canBeEdited.indexOf(a);
    });

    return sorted;
  }

  return {
    createdComments,
    hasCreatedComments,
    sort,
  };
}
